import React from 'react';
import { SearchOutlined } from '@ant-design/icons'

const SearchBar = ({ handleSearch, marginLeft, placeholder, value }) => {
    return (
        <div className="search-container" style={ marginLeft ? { marginLeft: 'auto' } : null}>
            <div>
                <img src="/assets/img/icons8-search.svg" alt="" />
            </div>
            <input
                type="search"
                style={{width: "100%", boxShadow: "none"}}
                placeholder={placeholder || 'Search...'}
                value={value}
                onChange={handleSearch}
            />
        </div>
    );
}

export default SearchBar;